import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { FragnoFooter } from 'fragno/react';
import SocialLink from './ui/SocialLink';
import IdMeLogo from './ui/IdMeLogo';
import { ReactComponent as XIcon } from '../img/icons/icon-x.svg';
import { ReactComponent as FacebookIcon } from '../img/icons/icon-facebook.svg';
import { ReactComponent as LinkedinIcon } from '../img/icons/icon-linkedin.svg';
import { ReactComponent as InstagramIcon } from '../img/icons/icon-instagram.svg';
import { FOOTER_URLS, SOCIAL_URLS, TERMS_URL } from '../constants';
import './Footer.scss';

// icon-linkedin.svg pads its glyph inside a 48x49 canvas; this crops to the glyph.
const LINKEDIN_GLYPH_VIEWBOX = '11 12 26 26';

// fragno re-parents these children on mount; adding or removing one afterwards throws.
const Footer = () => {
  const { t } = useTranslation();

  return (
    // `class`, not `className`: React doesn't translate it on custom elements.
    <FragnoFooter
      variant="minimal"
      ariaLabel={t('footer.ariaLabel')}
      class="fragno1-footer"
    >
      <div data-footer-part="brand">
        <a href={FOOTER_URLS.home} className="fragno1-footer__brand-link">
          <IdMeLogo ariaLabel={t('footer.logoLabel')} />
        </a>
      </div>
      <div data-footer-part="columns">
        <a href={FOOTER_URLS.accessibility}>{t('footer.linkAccessibility')}</a>
        <a href={TERMS_URL}>{t('footer.linkTerms')}</a>
        <a href={FOOTER_URLS.privacy}>{t('footer.linkPrivacy')}</a>
        <a href={FOOTER_URLS.washingtonPrivacy}>
          {t('footer.linkWashingtonPrivacy')}
        </a>
        <a href={FOOTER_URLS.biometrics}>{t('footer.linkBiometrics')}</a>
      </div>
      <div data-footer-part="meta">
        <section data-footer-sub="social" aria-label={t('footer.socialLabel')}>
          <h2>{t('footer.socialHeading')}</h2>
          <ul>
            <li>
              <SocialLink
                href={SOCIAL_URLS.x}
                icon={<XIcon />}
                label={t('footer.followOn', {
                  network: t('footer.networks.x'),
                })}
              />
            </li>
            <li>
              <SocialLink
                href={SOCIAL_URLS.facebook}
                icon={<FacebookIcon />}
                label={t('footer.followOn', {
                  network: t('footer.networks.facebook'),
                })}
              />
            </li>
            <li>
              <SocialLink
                href={SOCIAL_URLS.linkedin}
                icon={<LinkedinIcon viewBox={LINKEDIN_GLYPH_VIEWBOX} />}
                label={t('footer.followOn', {
                  network: t('footer.networks.linkedin'),
                })}
              />
            </li>
            <li>
              <SocialLink
                href={SOCIAL_URLS.instagram}
                icon={<InstagramIcon />}
                label={t('footer.followOn', {
                  network: t('footer.networks.instagram'),
                })}
              />
            </li>
          </ul>
        </section>
      </div>
    </FragnoFooter>
  );
};

export default memo(Footer);
